'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FileListItemProps {
  id: string;
  name: string;
  size: string;
  index: number;
  totalFiles: number;
  isMerging: boolean;
  onRemove: (id: string) => void;
  onMove: (index: number, direction: 'up' | 'down') => void;
}

export default function FileListItem({
  id,
  name,
  size,
  index,
  totalFiles,
  isMerging,
  onRemove,
  onMove,
}: FileListItemProps) {
  return (
    <div className="file-item flex items-center gap-3 p-3">
      {/* PDF Icon */}
      <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-primary-light">
        <Icon name="DocumentIcon" size={18} variant="solid" className="text-primary" />
      </div>

      {/* Name + Size */}
      <div className="flex-1 min-w-0">
        <p className="truncate font-heading font-semibold text-[13.5px] text-brand-dark">{name}</p>
        <p className="font-body text-[11px] text-brand-muted">{size}</p>
      </div>

      {/* Order controls */}
      <div className="flex items-center gap-1">
        <button
          onClick={() => onMove(index, 'up')}
          disabled={index === 0 || isMerging}
          className={`w-7 h-7 rounded-lg flex items-center justify-center transition-all disabled:opacity-30 bg-brand-surface text-brand-mid border border-brand-border
            ${index === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          aria-label="Move up"
        >
          <Icon name="ChevronUpIcon" size={13} />
        </button>

        <button
          onClick={() => onMove(index, 'down')}
          disabled={index === totalFiles - 1 || isMerging}
          className={`w-7 h-7 rounded-lg flex items-center justify-center transition-all disabled:opacity-30 bg-brand-surface text-brand-mid border border-brand-border
          ${index === totalFiles - 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          aria-label="Move down"
        >
          <Icon name="ChevronDownIcon" size={13} />
        </button>

        <button
          onClick={() => onRemove(id)}
          disabled={isMerging}
          className="w-7 h-7 rounded-lg flex items-center justify-center transition-all ml-1 disabled:opacity-50 bg-primary-light text-primary border border-primary-mid cursor-pointer"
          aria-label="Remove file"
        >
          <Icon name="XMarkIcon" size={13} />
        </button>
      </div>
    </div>
  );
}
